// extracted by mini-css-extract-plugin
export default {"wrapper":"Map_wrapper__-6qcc","map":"Map_map__hgaXb"};